import { useEffect, useState } from "react";

export function CursorMark() {
  const [pos, setPos] = useState({ x: -80, y: -80 });
  const [on, setOn] = useState(false);

  useEffect(() => {
    const fine = window.matchMedia("(pointer: fine)").matches;
    if (!fine) return;
    setOn(true);
    const move = (event: PointerEvent) => {
      setPos({ x: event.clientX, y: event.clientY });
    };
    window.addEventListener("pointermove", move);
    return () => window.removeEventListener("pointermove", move);
  }, []);

  if (!on) return null;

  return (
    <div
      className="pointer-events-none fixed z-[90] hidden mix-blend-difference md:block"
      style={{ left: pos.x, top: pos.y, transform: "translate(-50%, -50%)" }}
    >
      <div className="relative h-8 w-8">
        <span className="absolute left-1/2 top-0 h-full w-[2px] -translate-x-1/2 bg-acid" />
        <span className="absolute left-0 top-1/2 h-[2px] w-full -translate-y-1/2 bg-acid" />
      </div>
    </div>
  );
}
